import { render, staticRenderFns } from "./EditingFigureDefinition.vue?vue&type=template&id=2571bd0e&"
import script from "./EditingFigureDefinition.vue?vue&type=script&lang=js&"
export * from "./EditingFigureDefinition.vue?vue&type=script&lang=js&"
import style0 from "./EditingFigureDefinition.vue?vue&type=style&index=0&id=2571bd0e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports